/**
 * Created by Aleksandr on 02.05.2024
 */

const OldPiggyBankMissionLogic = function (mission, isNewMission) {
    this.mission = mission;

    if (isNewMission) {
        this.init();
    }
    this.onShowBottomButtonPriceWithAnimation = function () {};
    this.onSetBalance = function () {};
    this.updateProgress = function () {};
    this.lastShownAmount = this.mission.result;
    this.load(this.mission.details);

    if (!isNewMission && !this.getProduct()) {
        this.mission.complete();
    }
};

OldPiggyBankMissionLogic.prototype.init = function () {
    this.level = OldPiggyBankMissionLogic.CalcLevel();

    if (!this.getProduct()) {
        this.mission.complete();
        return;
    }

    this.mission.result = this.getStartAmount();

    this.mission.details = this.getInfo();
};

OldPiggyBankMissionLogic.prototype.getInfo = function () {
    return {
        level: this.level,
        amount: this.mission.result
    };
};

OldPiggyBankMissionLogic.prototype.saveProgress = function () {
    this.mission.update(0, this.getInfo());
};

OldPiggyBankMissionLogic.prototype.load = function (data) {
    this.level = data.level || 0;
    this.mission.result = data.amount || 0;
};

OldPiggyBankMissionLogic.prototype.gamePlayed = function (game) {
    if (game.outcome !== GameBase.OUTCOME_VICTORY) {
        return;
    }
    game.rewards.oldPiggyBank = this.getLevelReward();
};

OldPiggyBankMissionLogic.prototype.add = function (amount) {
    this.filled = undefined;
    this.unlocked = undefined;

    if (this.isFull()) {
        return;
    }

    this.mission.logEvent(Mission.EVENTS.MISSION_POINTS, { value: amount });
    this.mission.logEvent(Mission.EVENTS.MISSION_ACTION, { once: true });

    if (this.mission.result < this.getBaseAmount() && this.mission.result + amount >= this.getBaseAmount()) {
        this.unlocked = true;
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.PIGGY_BANK}_unlocked`);
    }

    this.mission.result += amount;

    if (this.isFull()) {
        this.filled = true;
        this.mission.result = Math.min(this.mission.result, this.getMaxAmount());
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.PIGGY_BANK}_full`);
    }

    if (this.unlocked || this.filled) {
        this.mission.setNeedReview(true);
    }

    this.saveProgress();
};

OldPiggyBankMissionLogic.prototype.getStartAmount = function () {
    return Math.round(this.getBaseAmount() - OldPiggyBankMissionLogic.WINS_TO_MINIMAL * this.getLevelReward());
};

OldPiggyBankMissionLogic.prototype.getBaseAmount = function () {
    return RewardsConfig.OldPiggyBank.hard[this.level];
};

OldPiggyBankMissionLogic.prototype.getLevelReward = function () {
    return Math.round((this.getMaxAmount() - this.getBaseAmount()) / OldPiggyBankMissionLogic.WINS_TO_FULFILL);
};

OldPiggyBankMissionLogic.prototype.getMaxAmount = function () {
    return Math.round(this.getBaseAmount() * OldPiggyBankMissionLogic.MAX_COEF / OldPiggyBankMissionLogic.WINS_TO_FULFILL) * OldPiggyBankMissionLogic.WINS_TO_FULFILL;
};

OldPiggyBankMissionLogic.prototype.getCurrentPrice = function () {
    return this.getProduct().getCurrentPrice();
};

OldPiggyBankMissionLogic.prototype.wasShown = function () {
    return this.isFull() && Math.abs(this.getLastShowAmountProgress() - this.mission.result) >= 0.01;
};

OldPiggyBankMissionLogic.prototype.showBottomButtonPriceWithAnimation = function () {
    this.onShowBottomButtonPriceWithAnimation();
};

OldPiggyBankMissionLogic.prototype.setBalance = function (value) {
    this.onSetBalance(value);
};

OldPiggyBankMissionLogic.prototype.getProgressGoals = function () {
    return [this.getBaseAmount(), this.getMaxAmount()];
};

OldPiggyBankMissionLogic.prototype.calculateProgress = function (amount) {
    return amount / this.getMaxAmount();
};

OldPiggyBankMissionLogic.prototype.getLastShowAmountProgress = function () {
    return this.lastShownAmount;
};

OldPiggyBankMissionLogic.prototype.setLastShowAmountProgress = function (amount) {
    this.lastShownAmount = amount;
};

OldPiggyBankMissionLogic.prototype.isFull = function () {
    return this.mission.result >= this.getMaxAmount();
};

OldPiggyBankMissionLogic.prototype.isReadyToFinish = function () {
    const state = this.getState();
    return state === OldPiggyBankMissionLogic.STATE_BASE || state === OldPiggyBankMissionLogic.STATE_FULL;
};

OldPiggyBankMissionLogic.prototype.wantToShowNewState = function () {
    return this.mission.needReview && this.isReadyToFinish();
};

OldPiggyBankMissionLogic.prototype.processEvent = function (options) {
    this.add(options.amount);
};

OldPiggyBankMissionLogic.prototype.canRemoveSilently = function () {
    return !this.getProduct();
};

OldPiggyBankMissionLogic.prototype.getFinishWindow = function () {
    return this.getProduct() ? this.mission.finishWindow : undefined;
};

OldPiggyBankMissionLogic.prototype.getProduct = function () {
    return Product.CreateById(OldPiggyBankMissionLogic.PRODUCTS[this.level], {
        type: "old_piggy_bank",
        mission: Mission.TYPE_OLD_PIGGY_BANK
    });
};

OldPiggyBankMissionLogic.prototype.getRewardCurrency = function () {
    return "hard";
};

OldPiggyBankMissionLogic.prototype.getGoal = function (goal) {
    return this.getRewardCurrency() === "soft" ? `@@${goal}` : `$$${goal}`;
};

OldPiggyBankMissionLogic.prototype.getReward = function () {
    const reward = {};
    reward[this.getRewardCurrency()] = this.mission.result;
    return reward;
};

OldPiggyBankMissionLogic.prototype.buy = function (callback) {
    const state = this.getState();
    if (state === OldPiggyBankMissionLogic.STATE_UNACTIVE) {
        callback(true);
        return;
    }

    const product = this.getProduct();
    product.reward = this.getReward();

    product.buy((success) => {
        if (success) {
            this.mission.complete();
            this.mission.wasDisplayedCompleted = true;
        }

        callback(success);
    });
};

OldPiggyBankMissionLogic.prototype.getControls = function () {
    return "MenuBarGoldItem";
};

OldPiggyBankMissionLogic.prototype.getState = function () {
    let state = OldPiggyBankMissionLogic.STATE_FULL;

    if (this.mission.result < this.getBaseAmount()) {
        state = OldPiggyBankMissionLogic.STATE_UNACTIVE;
    } else if (this.mission.result >= this.getBaseAmount() && this.mission.result < this.getMaxAmount()) {
        state = OldPiggyBankMissionLogic.STATE_BASE;
    }

    return state;
};

OldPiggyBankMissionLogic.prototype.checkAvailableBottomButton = function () {
    return this.lastShownAmount >= this.getBaseAmount();
};

OldPiggyBankMissionLogic.prototype.getDescriptionText = function () {
    const state = this.getState();

    let text = "OldPiggyBankWindow.text1.Full";
    if (state === OldPiggyBankMissionLogic.STATE_UNACTIVE) {
        text = "OldPiggyBankWindow.desc1";
    } else if (state === OldPiggyBankMissionLogic.STATE_BASE) {
        text = "OldPiggyBankWindow.desc2";
    }

    return text;
};

OldPiggyBankMissionLogic.prototype.canRemoveSilently = function () {
    return !this.isReadyToFinish() || this.mission.wasDisplayedCompleted;
};

OldPiggyBankMissionLogic.RestoreFind = function (context) {
    const mission = Restorable.FindRunningMission(context);
    return mission && mission.logic.getReward() ? mission : undefined;
};

OldPiggyBankMissionLogic.RestoreGive = function (mission) {
    const reward = mission.logic.getReward();

    if (mission.isRunning()) {
        mission.complete();
    }

    Restorable.displayWindow("OldPiggyBankRewardWindow", () => new RewardWindow(reward, { event: cleverapps.EVENTS.EARN.PURCHASE }));
};

OldPiggyBankMissionLogic.RestoreBoughtReward = function (context) {
    const mission = cleverapps.missionManager.findByType(context.mission);
    return mission && mission.logic && mission.logic.getReward();
};

OldPiggyBankMissionLogic.MAX_COEF = 1.5;

OldPiggyBankMissionLogic.CalcLevel = function () {
    const level = cleverapps.paymentsHistory.classify();
    return level === cleverapps.PaymentsHistory.BRACKET_BIGWHALE ? cleverapps.PaymentsHistory.BRACKET_WHALE : level;
};

OldPiggyBankMissionLogic.CanStart = function () {
    return Boolean(connector.payments.getProduct(OldPiggyBankMissionLogic.PRODUCTS[OldPiggyBankMissionLogic.CalcLevel()]));
};

OldPiggyBankMissionLogic.PRODUCTS = ["piggybank500", "piggybank1800", "piggybank6000", "piggybank25000"];

OldPiggyBankMissionLogic.WINS_TO_FULFILL = 15;
OldPiggyBankMissionLogic.WINS_TO_MINIMAL = 10;

OldPiggyBankMissionLogic.STATE_UNACTIVE = 0;
OldPiggyBankMissionLogic.STATE_BASE = 1;
OldPiggyBankMissionLogic.STATE_FULL = 2;

Restorable.BY_TYPE["old_piggy_bank"] = new Restorable({
    location: "main",
    find: OldPiggyBankMissionLogic.RestoreFind,
    give: OldPiggyBankMissionLogic.RestoreGive,
    boughtReward: OldPiggyBankMissionLogic.RestoreBoughtReward
});